import React from 'react'
import { Container } from 'react-bootstrap'
import Proptypes from 'prop-types'
import Marquee from 'react-fast-marquee'
// import { Swiper, SwiperSlide } from 'swiper/react'
// import { Autoplay } from 'swiper'
import cn from 'classnames'

import closerIcon from '~img/icons/closer.svg'
import w2e from '~img/icons/watch2earn.svg'
import beast from '~img/avatars/mrbeast.png'
import ksi from '~img/avatars/ksi.png'
import zilliqa from '~img/logos/zilliqa.png'
import jump from '~img/logos/jump-trading.png'
import au21 from '~img/logos/au21.png'
import ld from '~img/logos/ld.png'
import gbv from '~img/logos/gbv.png'

import 'swiper/css/autoplay'

import CreatorsCarousel from '~containers/Homepage/components/SectionHero/components/CreatorsCarousel'

const HighlightsCard = ({ id }) => {
  const stats = [
    { id: 1, amount: '+2M', title: 'Downloads' },
    { id: 3, amount: '+600K', title: 'Followers' },
    { id: 4, amount: '+1.7B', title: 'Subscribers' },
    { id: 2, amount: '+100', title: 'Creators on board' },
  ]

  const backers = [
    { id: 1, title: 'Mr Beast', img: beast, imgClass: '' },
    { id: 2, title: 'KSI', img: ksi, imgClass: '' },
    { id: 3, title: 'Jump Trading', img: jump, imgClass: '' },
    { id: 4, title: 'Zilliqa', img: zilliqa, imgClass: '' },
    { id: 5, title: 'AU21 Capital', img: au21, imgClass: 'bg-[#5D969C]' },
    { id: 6, title: 'GBV Capital', img: gbv, imgClass: '' },
    { id: 7, title: 'LD Capital', img: ld, imgClass: '' },
  ]

  return (
    <Container
      as="section"
      className="grid gap-y-12 mt-15 lg:gap-y-4 lg:mt-5 md:px-4"
      id={id}
    >
      <p
        className="font-semibold text-3xl md:text-[40px] text-black text-center mt-20 pb-0 md:pb-10"
        data-sal="slide-up"
        data-sal-delay="150"
        data-sal-easing="ease-out-back"
        data-sal-duration="2000"
      >
        Early Backers
      </p>

      <div
        className="w-full md:max-w-7xl mx-auto overflow-hidden"
        data-sal="slide-up"
        data-sal-delay="500"
        data-sal-easing="ease-out-back"
        data-sal-duration="2000"
      >
        <Marquee gradient={false} speed={50} direction="left">
          {backers.map((backer) => (
            <div
              key={backer.id}
              className="flex items-center gap-4 rounded-full border border-[#9d63c4] p-2 w-auto mx-3"
            >
              <div
                className={cn(
                  'w-12 h-12 rounded-full overflow-hidden border border-gray-300 flex items-center justify-center',
                  backer.imgClass
                )}
              >
                <img src={backer.img} alt={backer.title} />
              </div>
              <p className="font-medium text-lg md:text-2xl text-black pr-4">
                {backer.title}
              </p>
            </div>
          ))}
        </Marquee>
      </div>

      <div
        data-sal="slide-up"
        data-sal-delay="800"
        data-sal-easing="ease-out-back"
        data-sal-duration="2000"
      >
        <p className="font-semibold text-xl md:text-[40px] text-black text-center mt-0 md:mt-32 pb-0 md:pb-10">
          More than 100 creators issuing creator tokens
        </p>

        <CreatorsCarousel />
      </div>

      <p
        className="font-semibold text-3xl md:text-[40px] text-black text-center pt-16 md:pt-24 md:pb-16"
        id="vision"
      >
        Our Vision
      </p>

      <div className="flex flex-col gap-4">
        <div
          className=" w-full hover:bg-gradient-pill border border-light-purple rounded-2xl px-6 py-8 flex flex-col gap-12"
          data-sal="slide-up"
          data-sal-delay="50"
          data-sal-easing="ease-out-back"
          data-sal-duration="2000"
        >
          <div>
            <img src={closerIcon} alt="closer icon" className="w-10 h-10" />
            <p className="font-semibold text-black text-[22px]">
              Bringing creators and fans closer together
            </p>
            <p className="font-normal text-primary text-lg">
              XCAD’s platform gives both Creators & Fans a way to interact and
              reward each other for their loyalty. Fans get rewarded for
              watching, and Creators get rewarded with increased engagement.
            </p>
          </div>
        </div>

        <div
          className=" w-full hover:bg-gradient-pill border border-light-purple rounded-2xl px-6 py-8 flex flex-col gap-12"
          data-sal="slide-up"
          data-sal-delay="150"
          data-sal-easing="ease-out-back"
          data-sal-duration="2000"
        >
          <div>
            <img src={w2e} alt="play icon" className="w-10 h-10" />
            <p className="font-semibold text-black text-[22px]">
              The #Watch2Earn Revolution
            </p>
            <p className="font-normal text-primary text-lg">
              #Play2Earn & Move2Earn achieved mainstream adoption, now it’s time
              for #Watch2Earn - there are 2.5 billion active YouTube users, our
              system rewards viewers for watching Creators.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {stats.map((stat) => {
            return (
              <div
                key={stat.id}
                className="flex flex-col items-center justify-center border border-light-purple rounded-xl px-6 py-8 hover:bg-gradient-pill"
                data-sal="slide-left"
                data-sal-delay={Math.min((stat.id + 1) * 200, 1000)}
                data-sal-easing="ease-out-back"
                data-sal-duration="2000"
              >
                <p className="font-semibold text-5xl text-black tracking-tight">
                  {stat.amount}
                </p>
                <p className="font-normal text-primary text-lg whitespace-nowrap">
                  {stat.title}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </Container>
  )
}

export default HighlightsCard

HighlightsCard.defaultProps = {
  id: '',
}

HighlightsCard.propTypes = {
  id: Proptypes.string,
}
